// extracted by LIB_CSS_EXTRACT_LOADER
import "./avatar_module.css"
export default {"root":"root-zQhInF","image":"image-cfk_Wf","fallback":"fallback-AqFt3B"};